  <div *ngIf="imgSource" class="container image-container">
    <img [src]="imgSource"/>
  </div>


